import { environment } from 'apps/dstv-via-streaming/src/environments/environment';
import { NumberUtils } from '../../../utils/number.utils';
import { MCTransactionTypes, PaymentAttribution } from './enums/mc-transaction-types';
import { PaymentRequestType } from './payment-request';

export interface PaymentMethodOption {
  value: any;
  description: string;
  icon: string[];
  data?: any;
}
export interface PaymentRequestRedirectResponse {
  redirectUrl: string;
  transactionId: string;
  paymentType?: string;
  orderId?: string;
}

const PayAtPaymentOptions = new Map<string, any>([
  [
    'CARD',
    {
      value: 'CARD',
      icon: ['MASTERC.png', 'VISA.png'],
      description: 'Credit or Debit Card',
    },
  ],
  [
    'EFT',
    {
      value: 'EFT',
      icon: ['FNB.png', 'ABSA.png'],
      description: 'Instant EFT',
      moreIcon: '+5',
    },
  ],
  [
    'CAPITEC_EFT',
    {
      value: 'CAPITEC_EFT',
      icon: ['CAPITEC.png'],
      description: 'Capitec EFT',
    },
  ],
  [
    'ONE_VOUCHER',
    {
      value: 'ONE_VOUCHER',
      icon: ['VOUCHER.svg'],
      description: 'Voucher',
    },
  ],
]);

export interface PayAtRedirectResponse {
  paymentMethodName:
    | 'CARD'
    | 'CAPITEC_EFT'
    | 'TEST_WEB_ovQfHewrjy'
    | 'TEST_WEB_CLFPcbPPjR'
    | 'EFT'
    | 'ONE_VOUCHER'
    | string;
  paymentUrl: string;
}

export interface PayAtRedirectResolution {
  paymentOptions: PaymentMethodOption[];
}

export class PaymentRequestPayAt implements PaymentRequestType<PayAtRedirectResponse[]> {
  constructor(private request: any) {}

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values,
    };
    return this;
  }

  getDependantValues() {
    return Promise.resolve(this);
  }

  toPaymentRequestObject() {
    const { customerNumber, amount, successReturnURL, failureReturnURL, location, paymentAttribution } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    return {
      messageId: crypto.randomUUID(),
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      clientReference: customerNumber,
      successUrl: successReturnURL,
      failedUrl: failureReturnURL,
      cancelledUrl: location,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  toTokenRequestObject() {
    const { customerNumber, amount, accountNumber, location, paymentAttribution } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    return {
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      customerId: customerNumber,
      customerRedirectUrl: location,
      clientReference: `${accountNumber}-${customerNumber}-ZA`,
      qrTags: [`jid=${paymentAttribution}`],
    };
  }

  handleResponse(response: PayAtRedirectResponse[] | PaymentRequestRedirectResponse): Promise<PayAtRedirectResolution> {
    // TODO: improve conditional type logic
    if (Object.prototype.hasOwnProperty?.call(response, 'redirectUrl')) {
      const res = response as PaymentRequestRedirectResponse;
      // sessionStorage.setItem('dstv-ss.tid', `${res.transactionId}:${res.paymentType}`);
      // window.location.assign(res.redirectUrl);
      if (this.request.isDiscovery) {
        return Promise.resolve({
          paymentOptions: [
            {
              value: 'CARD',
              icon: ['DISCOVERY.svg'],
              description: 'Discovery',
              data: res.redirectUrl,
            },
          ],
        });
      }
      return Promise.resolve({
        paymentOptions: [
          {
            value: 'CARD',
            icon: ['MASTERC.png', 'VISA.png'],
            description: 'Recurring Card Payment',
            data: res.redirectUrl,
          },
        ],
      });

      // return Promise.resolve(false)
    }

    const res = response as PayAtRedirectResponse[];
    return Promise.resolve({
      paymentOptions: res
        .map((item) => {
          if (
            PayAtPaymentOptions.has(item.paymentMethodName) &&
            environment.PAYMENT_TYPES.includes(item.paymentMethodName)
          ) {
            return {
              ...PayAtPaymentOptions.get(item.paymentMethodName),
              data: item.paymentUrl,
            };
          }
        })
        .filter((item) => item !== undefined),
    });
  }

  public static ParseURLResponse = (location: Location) => {
    const params = [
      'digiapiPaymentStatus',
      'digiapiPaymentMethod',
      'digiapiExternalRef',
      'payatTranId',
      'payatReferenceNum',
      'digiapiResponseMsg',
    ];
    const searchParams = new URLSearchParams(location.search);
    const values = params.reduce((prev, curr) => {
      return searchParams.has(curr) ? { ...prev, [curr]: decodeURI(`${searchParams.get(curr)}`) } : prev;
    }, {});

    return Object.keys(values)?.length
      ? (values as {
          digiapiPaymentStatus?: string;
          digiapiPaymentMethod?: string;
          digiapiExternalRef?: string;
          payatTranId?: string;
          payatReferenceNum?: string;
          digiapiResponseMsg?: string;
        })
      : null;
  };
}
